import { AbacoVuexModule, State } from "@abaco/web-common/src/app";
import { AllowanceFixedPercentage, AllowanceScalarePercentage, CertificateCodesDictionary, CertigrafCampaignType, CertigrafCertificateInfo, CertigrafOrganizationsDictionary, CertigrafPlot, CertigrafPlotData, CertigrafPrecertificateData, CertigrafPreCertificateType, CompensationPercentage, CondifesaSubject, Council, EventType, InsuranceCompany, IntermediaryCompany, ManagerSubject, PhytoFund, PhytopathyType, PlantType, PreCertificateOutcome, Product, ProductVarietyType, UncoveredPercentage } from "./models/CertigrafModel";

export default class ExampleVuexModule extends AbacoVuexModule {
    @State() exampleNavBarFilterOpen!: boolean;
    @State() curStep!: number;
    @State({ default: 0 }) lastStep!: number;
    @State({ default: false }) fl_bio!: boolean;
    @State({ default: false }) fl_damage_hail!: boolean;
    @State({ default: false }) fl_damage_other!: boolean;
    @State({ default: false }) fl_insure_other_company!: boolean;
    @State({ default: null }) assuranceNotes!: string | null;
    @State({ default: null }) availablePlots!: CertigrafPlot[] | null;
    @State({ default: null }) availableProducts!: Product[] | null;
    @State({ default: null }) campaignTypeDictionary!: CertigrafCampaignType[] | null;
    @State({ default: null }) certificateCodesDictionary!: CertificateCodesDictionary | null;
    @State({ default: null }) councilsDictionary!: Council[] | null;
    @State({ default: null }) insure_other_company!: string | null;
    @State({ default: null }) insure_perc!: number | null;
    @State({ default: null }) ist_value!: number | null;
    @State({ default: null }) organizationsDictionary!: CertigrafOrganizationsDictionary | null;
    @State({ default: null }) pai!: number | null;
    @State({ default: null }) precertificateData!: CertigrafPrecertificateData | null;
    @State({ default: null }) prize_qt!: number | null;
    @State({ default: null }) prize_qt_intermediary!: number | null;
    @State({ default: null }) quantity_qt_ha!: number | null;
    @State({ default: null }) selectedCampaignType!: CertigrafCampaignType | null;
    @State({ default: null }) selectedCompany!: InsuranceCompany | null;
    @State({ default: null }) selectedCondifesaSubject!: CondifesaSubject | null;
    @State({ default: null }) selectedContractType!: CertigrafPreCertificateType | null;
    @State({ default: null }) selectedCouncil!: Council | null;
    @State({ default: null }) selectedEvents!: EventType[] | null;
    @State({ default: null }) selectedFixedDeductible!: AllowanceFixedPercentage | null;
    @State({ default: null }) selectedIndemnity!: CompensationPercentage | null;
    @State({ default: null }) selectedIntermediaryCompany!: IntermediaryCompany | null;
    @State({ default: null }) selectedPhytopathies!: PhytopathyType[] | null;
    @State({ default: [] }) selectedPlots!: CertigrafPlot[];
    @State({ default: null }) selectedProduct!: Product | null;
    @State({ default: null }) selectedProtectionSystem!: PlantType | null;
    @State({ default: null }) selectedScaledDeductible!: AllowanceScalarePercentage | null;
    @State({ default: null }) selectedSubject!: ManagerSubject | CondifesaSubject | null;
    @State({ default: null }) selectedUncovered!: UncoveredPercentage | null;
    @State({ default: null }) standardValueTotal!: number | null;
    @State({ default: null }) totalAssurancedArea!: number | null;
    @State({ default: null }) totalAssurancePrice!: number | null;
    @State({ default: null }) ensure_value_tot_intermediary!: number | null;
    @State({ default: null }) totalPlotArea!: number | null;
    @State({ default: null }) vmi!: number | null;
    @State({ default: true }) fl_other_policy!: boolean;
    @State({ default: 0 }) formMode!: number; // 0: create | 1: modify | 2: view
    @State({ default: null }) tmpPlotData!: CertigrafPlotData | null;
    @State({ default: false }) plotDataFormOpen!: boolean;
    @State({ default: "" }) currentPlotName!: string;
    @State({ default: -1 }) currentPlotArea!: number;
    @State({ default: null }) currentPlotId!: number | null;
    @State({ default: null }) plotsData!: Map<number, CertigrafPlotData> | null;
    @State({ default: false }) openNewCertificateModal!: boolean;
    @State({ default: -1 }) totalSelectedPlotsArea!: number;
    @State({ default: -1 }) totalSelectedAssuranceArea!: number;
    @State({ default: false }) isIntermediaryMode!: boolean;
    @State({ default: false }) isCondifesaMode!: boolean;
    @State({ default: null }) intermediaryAssuranceNotes!: string | null;
    @State({ default: 0 }) selectedThresholdIntermediary!: number | null;
    @State({ default: 0 }) selectedThreshold!: number | null;
    @State({ default: [] }) selectedIntermediaryEvents!: EventType[] | null;
    @State({ default: null }) selectedIntermediaryFixedDeductible!: AllowanceFixedPercentage | null;
    @State({ default: null }) selectedIntermediaryIndemnity!: CompensationPercentage | null;
    @State({ default: [] }) selectedIntermediaryPhytopathies!: PhytopathyType[] | null;
    @State({ default: null }) selectedIntermediaryScaledDeductible!: AllowanceScalarePercentage | null;
    @State({ default: null }) selectedIntermediaryUncovered!: UncoveredPercentage | null;
    @State({ default: null }) totalInsuredValue!: number | null;
    @State({ default: null }) tariffRate!: number | null;
    @State({ default: null }) premium!: number | null;
    @State({ default: null }) outcomeReason!: string | null;
    @State({ default: null }) selectedOutcomeCompany!: InsuranceCompany | null;
    @State({ default: null }) outcomeType!: PreCertificateOutcome | null;
    @State({ default: null }) dialogOnCloseCallback!: () => void | null;
    @State({ default: null }) dialogOnAcceptCallback!: () => void | null;
    @State({ default: null }) dialogOnDenyCallback!: () => void | null;
    @State({ default: null }) dialogTitle!: string | null;
    @State({ default: null }) dialogContent!: string[] | null;
    @State({ default: false }) dialogOpen!: boolean;
    @State({ default: null }) selectedCertificateInfo!: CertigrafCertificateInfo | null;
    @State({ default: false }) disableMapSelectFunctionality!: boolean;
    @State({ default: null }) varietyDictionary!: ProductVarietyType[] | null;
    @State({ default: false }) forceProductsReload!: boolean;
    @State({ default: null }) newPlotWkt!: string | null;
    @State({ default: null }) condifesaOverride!: string | null;
    @State({ default: {fund_id: "", name: "", gtee_events: "", condifesa_org: ""} }) selectedPhytoFund!: PhytoFund;
    @State({ default: true }) isSignEnabled!: boolean;
    @State({ default: false }) isCompatibilitySignMode!: boolean;
}
